import { combineReducers } from 'redux';
import { content, contentHasErrored, contentIsLoading } from './content';
import { donors, donorsHasErrored, donorsIsLoading } from './donors';
import { screen, active_module, options } from './display';

export default combineReducers({
    content,
    contentHasErrored,
    contentIsLoading,
    donors,
    donorsHasErrored,
    donorsIsLoading,
    screen,
    active_module,
    options
});


// WEBPACK FOOTER //
// ./src/reducers/index.js